import { render } from "./UploadModulistica.vue?vue&type=template&id=0d39636b&scoped=true"
import script from "./UploadModulistica.vue?vue&type=script&lang=js"
export * from "./UploadModulistica.vue?vue&type=script&lang=js"

import "./UploadModulistica.vue?vue&type=style&index=0&id=0d39636b&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d39636b"]])

export default __exports__